import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgTool = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.025 14.25L10.2 7.425c.675-1.725.3-3.75-1.125-5.175-1.5-1.5-3.75-1.8-5.55-.975L6.75 4.5 4.5 6.75 1.2 3.525c-.9 1.8-.525 4.05.975 5.55C3.6 10.5 5.625 10.875 7.35 10.2l6.825 6.825c.3.3.75.3 1.05 0L16.95 15.3c.375-.3.375-.825.075-1.05z" })
});
export default SvgTool;
